import { supabase } from '@/integrations/supabase/client';
import { toast } from 'sonner';

export type UserStatus = 'pending' | 'approved' | 'rejected' | null;

export const SESSION_TOKEN_KEY = 'active_session_token';
export const POLL_INTERVAL = 15000;
const MAU_STORAGE_KEY = 'mau_recorded_date';

export async function checkPendingInvites(email: string | undefined) {
  if (!email) return;
  try {
    const { count: challengeInvites } = await supabase
      .from('challenge_invites')
      .select('id', { count: 'exact', head: true })
      .eq('invitee_email', email)
      .eq('status', 'pending');

    const { count: groupInvites } = await supabase
      .from('study_group_invites')
      .select('id', { count: 'exact', head: true })
      .eq('invitee_email', email)
      .eq('status', 'pending');

    const totalInvites = (challengeInvites || 0) + (groupInvites || 0);
    if (totalInvites > 0) {
      const description =
        challengeInvites && groupInvites
          ? `${challengeInvites} desafio(s) e ${groupInvites} grupo(s)`
          : challengeInvites
            ? `${challengeInvites} convite(s) de desafio`
            : `${groupInvites} convite(s) de grupo`;

      toast.info(
        `Você tem ${totalInvites} convite${totalInvites > 1 ? 's' : ''} pendente${totalInvites > 1 ? 's' : ''}!`,
        {
          description,
          action: {
            label: 'Ver convites',
            onClick: () => (window.location.href = '/challenges'),
          },
          duration: 8000,
        },
      );
    }
  } catch (error) {
    console.warn('Could not check pending invites:', error);
  }
}

export async function fetchUserStatus(userId: string): Promise<UserStatus> {
  try {
    const { data, error } = await supabase
      .from('profiles')
      .select('status')
      .eq('id', userId)
      .maybeSingle();
    if (error || !data) return null;
    return (data.status as UserStatus) || null;
  } catch {
    return null;
  }
}

export async function recordMauOncePerDay() {
  try {
    const today = new Date().toISOString().slice(0, 10);
    if (localStorage.getItem(MAU_STORAGE_KEY) === today) return;
    const { error } = await supabase.rpc('record_mau');
    if (!error) localStorage.setItem(MAU_STORAGE_KEY, today);
  } catch {
    // silencioso — tracking de MAU não pode quebrar login
  }
}
